// extracted by mini-css-extract-plugin
module.exports = {"textColumns":"TextColumns-module--textColumns--k_Yhx"};